import React from "react";
import styles from "./Schedule.module.scss";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { smmScheduleTableData } from "../../../../../views/AdminPortal/dummyData";
import PostComposer from "../PostComposer/PostComposer";

const Schedule = () => {
    const columns = [
        {
            name: "Date",
            selector: (row) => row.date,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Time",
            selector: (row) => row.time,
            center: "true",
        },
        {
            name: "Platform",
            selector: (row) => row.platform,
            center: "true",
        },
        {
            name: "Content Preview",
            selector: (row) => row.content,
            center: "true",
            minWidth: "300px",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            center: "true",
            minWidth: "160px",
        },
    ];

    return (
        <div className={styles.scheduleContainer}>
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={smmScheduleTableData}
                    columns={columns}
                    type="grayShadow"
                    highlightOnHover
                    responsive
                />
            </div>
            <PostComposer />
        </div>
    );
};

export default Schedule;